import React from 'react'

const TextAreaWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className='facility-label col-md-3' htmlFor={props.name}>{props.label}</label>
    <div className='col-md-8'>
      <textarea {...props} ref={ref} className='form-control' rows='5'></textarea>
    </div>
  </div>
))

export default TextAreaWrapper
